// extracted by mini-css-extract-plugin
export var logo = "logo-module--logo--7ab6c w-full h-auto";
export var logoWrapper = "logo-module--logoWrapper--08446 w-ms14 block";